import React from 'react';
import { PaymentMethod } from 'types/paymentMethod';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { paymentMethodTableTemplate } from '../../template/paymentMethodTableTemplate';

type PaymentMethodListTableProps = {
  paymentMethods: PaymentMethod[];
};

const PaymentMethodListTable: React.FC<PaymentMethodListTableProps> = ({ paymentMethods }) => {
  return (
    <DataGridList
      template={paymentMethodTableTemplate}
      rows={paymentMethods}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/payment-methods/${row.id}`)}
      fileName="formas_de_pagamento"
      sheetName="Formas de pagamento"
    />
  );
};

export default PaymentMethodListTable;
